import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { motion, useScroll, useTransform } from 'framer-motion';
import { Crown, UtensilsCrossed, Users, ChefHat, Sparkles, Star, ArrowRight, Check, Play, Quote } from 'lucide-react';
import { Button } from '../components/ui/button';

// User provided images
const LOGO_URL = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/zkwjbg2h_Royal%20Delights%20Logo.png";
const CHEF_JAYLON = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/n5u32e78_20200430_145615%20%281%29.jpg";
const SALMON_IMG = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/pvrclu49_RoyalDragon_HibachiSalmon.jpg";
const SHRIMP_SKEWERS_IMG = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/rq0obo8x_RoyalDragon_ShripSkewers.jpg";
const HIBACHI_STEAK_IMG = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/iftkz5tu_RoyalDragon_HibachiSteak.jpg";
const HIBACHI_SHRIMP_IMG = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/nb10gqiy_RoyalDragon_HibachiShrimp.jpg";
const HIBACHI_CHICKEN_IMG = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/jtbzavwk_RoyalDragon_HibachiChicken.jpg";
const LOBSTER_IMG = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/uyehacwk_broiled_lobster-500x500.jpg";
// New premium plated images
const STEAK_LOBSTER_PLATE = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/6xq6raql_copilot_image_1770938235981.jpeg";
const STEAK_SHRIMP_PLATE = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/7ohomzqa_image_1770937982622.jpeg";
const BENTO_SPREAD = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/jt37pe3s_image_1770939759278.jpeg";
const COMBO_PLATE = "https://customer-assets.emergentagent.com/job_hibachi-feasts/artifacts/u77mu1si_copilot_image_1770940164719.jpeg";

// New curated images - premium, warm, royal, hospitality-driven
const HERO_IMAGE = "https://images.unsplash.com/photo-1663530761401-15eefb544889?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2OTV8MHwxfHNlYXJjaHwxfHxjaGVmJTIwcGxhdGluZyUyMGdvdXJtZXQlMjBmb29kJTIwY2xvc2UlMjB1cCUyMGRhcmslMjBiYWNrZ3JvdW5kfGVufDB8fHx8MTc3MDg2NTMyNnww&ixlib=rb-4.1.0&q=85";
const LUXURY_TABLE = "https://images.unsplash.com/photo-1674818534586-78ababb77227?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBwcml2YXRlJTIwZGluaW5nJTIwYmxhY2slMjBnb2xkJTIwdGFibGUlMjBzZXR0aW5nJTIwY2FuZGxlbGlnaHR8ZW58MHx8fHwxNzcwODY1NDM2fDA&ixlib=rb-4.1.0&q=85";
const DINNER_PARTY = "https://images.unsplash.com/photo-1768508950434-fc76c9f3ed9f?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwzfHxlbGVnYW50JTIwZGlubmVyJTIwcGFydHklMjBndWVzdHMlMjBsYXVnaGluZyUyMGNoYW1wYWduZSUyMGRhcmslMjBhbWJpZW50fGVufDB8fHx8MTc3MDg2NTQ2NXww&ixlib=rb-4.1.0&q=85";
const CHEF_HANDS = "https://images.unsplash.com/photo-1661505300261-d45fa3e29890?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDk1ODF8MHwxfHNlYXJjaHwxfHxwcm9mZXNzaW9uYWwlMjBjaGVmJTIwaGFuZHMlMjBwbGF0aW5nJTIwZm9vZCUyMGRhcmslMjBtb29keXxlbnwwfHx8fDE3NzA4NjU0NDR8MA&ixlib=rb-4.1.0&q=85";
const GOLDEN_CROWN = "https://images.unsplash.com/photo-1695503117452-22dfcc72e6a5?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHwxfHxsdXh1cnklMjBnb2xkJTIwY3Jvd24lMjByb3lhbCUyMGFlc3RoZXRpYyUyMGRhcmt8ZW58MHx8fHwxNzcwODY1NDQ4fDA&ixlib=rb-4.1.0&q=85";
const CANDLELIGHT = "https://images.unsplash.com/photo-1570459467207-bda077e3e3be?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1ODh8MHwxfHNlYXJjaHwzfHxsdXh1cnklMjBwcml2YXRlJTIwZGluaW5nJTIwYmxhY2slMjBnb2xkJTIwdGFibGUlMjBzZXR0aW5nJTIwY2FuZGxlbGlnaHR8ZW58MHx8fHwxNzcwODY1NDM2fDA&ixlib=rb-4.1.0&q=85";
const CHANDELIER = "https://images.unsplash.com/photo-1619854485190-4f6de196d292?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MDV8MHwxfHNlYXJjaHw0fHxsdXh1cnklMjBnb2xkJTIwY3Jvd24lMjByb3lhbCUyMGFlc3RoZXRpYyUyMGRhcmt8ZW58MHx8fHwxNzcwODY1NDQ4fDA&ixlib=rb-4.1.0&q=85";

const fadeInUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.8, ease: [0.25, 0.46, 0.45, 0.94] } }
};

const fadeIn = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { duration: 1, ease: "easeOut" } }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.2, delayChildren: 0.1 }
  }
};

const scaleIn = {
  hidden: { opacity: 0, scale: 0.9 },
  visible: { opacity: 1, scale: 1, transition: { duration: 0.8, ease: "easeOut" } }
};

export const HomePage = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  const heroRef = useRef(null);
  const { scrollYProgress } = useScroll({
    target: heroRef,
    offset: ["start start", "end start"]
  });
  
  const heroImageY = useTransform(scrollYProgress, [0, 1], ["0%", "30%"]);
  const heroOpacity = useTransform(scrollYProgress, [0, 0.5], [1, 0]);

  useEffect(() => {
    setIsLoaded(true);
  }, []);

  const services = [
    {
      image: LUXURY_TABLE,
      title: "Plated Royal Dinner",
      subtitle: "Intimate Excellence",
      description: "An intimate, chef-driven dining experience with refined plating and dedicated service for 2-12 guests.",
      price: "$65-$125/guest"
    },
    {
      image: DINNER_PARTY,
      title: "Royal Feast Buffet",
      subtitle: "Celebratory Gatherings",
      description: "A soulful, celebratory buffet designed for families, gatherings, and large events of 10-40 guests.",
      price: "$55-$100/guest"
    },
    {
      image: CHEF_HANDS,
      title: "Private Chef Experience",
      subtitle: "Bespoke Luxury",
      description: "Premium hibachi prepared fresh on-site with warmth, culture, and luxury service in your space.",
      price: "Custom Quote"
    }
  ];

  const whyChooseUs = [
    { text: "Soulful, deeply seasoned flavor", icon: "✦" },
    { text: "Luxury-level hospitality", icon: "✦" },
    { text: "Fully staffed and over-prepared", icon: "✦" },
    { text: "Premium ingredients only", icon: "✦" },
    { text: "Seamless setup to breakdown", icon: "✦" },
    { text: "Cultural warmth and excellence", icon: "✦" }
  ];

  const signatureDishes = [
    { name: "The Royal Duo", subtitle: "Steak & Shrimp", price: "$70", image: STEAK_SHRIMP_PLATE },
    { name: "The Emperor's Surf & Turf", subtitle: "Filet & Salmon", price: "$75", image: COMBO_PLATE },
    { name: "The King's Surf Feast", subtitle: "Steak & Lobster", price: "$90", image: STEAK_LOBSTER_PLATE },
    { name: "The Grand Royal", subtitle: "Full Banquet", price: "$85", image: BENTO_SPREAD }
  ];

  const testimonials = [
    {
      quote: "Royal Delights transformed our anniversary into an unforgettable evening. The attention to detail, the warmth of Chef Jaylon, and the exquisite flavors left us speechless.",
      author: "The Williams Family",
      event: "Anniversary Celebration"
    },
    {
      quote: "From the first flame to the last bite, pure magic. Our guests are still talking about it weeks later. This is what luxury hospitality should feel like.",
      author: "Marcus & Tanya",
      event: "Birthday Dinner"
    },
    {
      quote: "Professional, soulful, and absolutely luxurious. We felt celebrated and cared for from start to finish. Already planning our next booking.",
      author: "The Johnson Family",
      event: "Family Reunion"
    }
  ];

  return (
    <div data-testid="home-page" className="min-h-screen bg-[#050505] overflow-hidden">
      
      {/* ==================== HERO SECTION ==================== */}
      <section ref={heroRef} className="relative min-h-[100vh] flex items-center overflow-hidden">
        {/* Parallax Background */}
        <motion.div 
          className="absolute inset-0 z-0"
          style={{ y: heroImageY }}
        >
          <img 
            src={HERO_IMAGE} 
            alt="Chef plating gourmet food" 
            className="w-full h-[120%] object-cover"
          />
          <div className="absolute inset-0 bg-gradient-to-r from-black/90 via-black/70 to-black/50" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#050505] via-transparent to-transparent" />
        </motion.div>

        {/* Floating Golden Elements */}
        <div className="absolute top-20 right-20 w-64 h-64 opacity-10">
          <img src={GOLDEN_CROWN} alt="" className="w-full h-full object-contain" />
        </div>

        {/* Hero Content */}
        <motion.div 
          className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full"
          style={{ opacity: heroOpacity }}
          initial="hidden"
          animate={isLoaded ? "visible" : "hidden"}
          variants={staggerContainer}
        >
          <div className="max-w-3xl">
            {/* Logo Badge */}
            <motion.div variants={fadeInUp} className="mb-8">
              <div className="inline-flex items-center gap-4 bg-white/5 backdrop-blur-md border border-white/10 rounded-full px-4 py-2">
                <img src={LOGO_URL} alt="Royal Delights" className="w-10 h-10 object-contain" />
                <span className="text-[#D4AF37] font-body text-sm uppercase tracking-[0.2em]">Atlanta's Premier Hibachi</span>
              </div>
            </motion.div>

            {/* Main Headline */}
            <motion.h1 
              variants={fadeInUp}
              className="font-heading text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-bold leading-[0.95] mb-8"
            >
              <span className="text-[#F5F5F0] block">Soulful</span>
              <span className="text-gold-gradient italic block">Luxury</span>
              <span className="text-[#F5F5F0] block">Hibachi</span>
            </motion.h1>

            {/* Subheadline */}
            <motion.p 
              variants={fadeInUp}
              className="font-body text-lg sm:text-xl text-[#A1A1AA] max-w-xl mb-12 leading-relaxed"
            >
              Where cultural warmth meets refined excellence. Private chef experiences 
              crafted for life's most meaningful celebrations.
            </motion.p>

            {/* CTA Buttons */}
            <motion.div variants={fadeInUp} className="flex flex-wrap gap-4">
              <Link to="/booking">
                <Button 
                  data-testid="hero-cta-btn"
                  className="bg-[#D4AF37] text-black hover:bg-[#C5A028] font-semibold rounded-full px-8 py-6 text-base transition-all duration-300 hover:scale-105 shadow-[0_0_30px_-10px_rgba(212,175,55,0.5)]"
                >
                  Reserve Your Experience
                  <ArrowRight className="ml-2 w-5 h-5" />
                </Button>
              </Link>
              <Link to="/menu">
                <Button 
                  variant="outline"
                  data-testid="hero-menu-btn"
                  className="border border-white/20 text-[#F5F5F0] hover:bg-white/10 bg-transparent rounded-full px-8 py-6 text-base transition-all duration-300"
                >
                  Explore Menu
                </Button>
              </Link>
            </motion.div>
          </div>
        </motion.div>

        {/* Scroll Indicator */}
        <motion.div 
          className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10"
          animate={{ y: [0, 10, 0] }}
          transition={{ repeat: Infinity, duration: 2.5, ease: "easeInOut" }}
        >
          <div className="flex flex-col items-center gap-2">
            <span className="text-[#A1A1AA] text-xs uppercase tracking-widest font-body">Scroll</span>
            <div className="w-px h-12 bg-gradient-to-b from-[#D4AF37] to-transparent" />
          </div>
        </motion.div>
      </section>

      {/* ==================== BRAND STATEMENT ==================== */}
      <section className="py-32 bg-[#050505] relative">
        <div className="absolute inset-0 opacity-5">
          <img src={CANDLELIGHT} alt="" className="w-full h-full object-cover" />
        </div>
        <div className="max-w-5xl mx-auto px-6 lg:px-8 text-center relative z-10">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            <motion.div variants={fadeIn} className="mb-6">
              <Crown className="w-10 h-10 text-[#D4AF37] mx-auto" />
            </motion.div>
            <motion.p 
              variants={fadeInUp}
              className="font-heading text-3xl sm:text-4xl lg:text-5xl text-[#F5F5F0] leading-relaxed italic"
            >
              "Every dish tells a story of <span className="text-[#D4AF37]">heritage</span>, 
              every gathering becomes a <span className="text-[#D4AF37]">celebration</span>, 
              and every guest feels like <span className="text-[#D4AF37]">royalty</span>."
            </motion.p>
            <motion.p variants={fadeInUp} className="mt-8 text-[#A1A1AA] font-body text-sm uppercase tracking-widest">
              — The Royal Delights Promise
            </motion.p>
          </motion.div>
        </div>
      </section>

      {/* ==================== SERVICES BENTO GRID ==================== */}
      <section className="py-24 lg:py-32 bg-[#050505]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            {/* Section Header */}
            <motion.div variants={fadeInUp} className="mb-16">
              <p className="text-[#D4AF37] uppercase tracking-[0.2em] text-sm mb-4 font-body">Our Offerings</p>
              <h2 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#F5F5F0]">
                Curated Experiences
              </h2>
            </motion.div>

            {/* Bento Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
              {/* Large Featured Card */}
              <motion.div 
                variants={scaleIn}
                className="lg:col-span-7 lg:row-span-2 group relative overflow-hidden rounded-2xl bg-[#121212] border border-white/5"
                data-testid="service-card-0"
              >
                <div className="aspect-[4/3] lg:aspect-auto lg:h-full relative">
                  <img 
                    src={services[0].image} 
                    alt={services[0].title}
                    className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                  <div className="absolute bottom-0 left-0 right-0 p-8 lg:p-12">
                    <span className="text-[#D4AF37] text-sm uppercase tracking-widest font-body">{services[0].subtitle}</span>
                    <h3 className="font-heading text-3xl lg:text-4xl font-bold text-[#F5F5F0] mt-2 mb-4">{services[0].title}</h3>
                    <p className="font-body text-[#A1A1AA] mb-4 max-w-md">{services[0].description}</p>
                    <span className="inline-block bg-[#D4AF37]/20 text-[#D4AF37] px-4 py-2 rounded-full text-sm font-body">
                      {services[0].price}
                    </span>
                  </div>
                </div>
              </motion.div>

              {/* Smaller Cards */}
              {services.slice(1).map((service, index) => (
                <motion.div 
                  key={index}
                  variants={scaleIn}
                  className="lg:col-span-5 group relative overflow-hidden rounded-2xl bg-[#121212] border border-white/5"
                  data-testid={`service-card-${index + 1}`}
                >
                  <div className="aspect-[16/9] relative">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
                    />
                    <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/40 to-transparent" />
                    <div className="absolute bottom-0 left-0 right-0 p-6">
                      <span className="text-[#D4AF37] text-xs uppercase tracking-widest font-body">{service.subtitle}</span>
                      <h3 className="font-heading text-2xl font-bold text-[#F5F5F0] mt-1 mb-2">{service.title}</h3>
                      <p className="font-body text-sm text-[#A1A1AA] mb-3 line-clamp-2">{service.description}</p>
                      <span className="inline-block bg-[#D4AF37]/20 text-[#D4AF37] px-3 py-1 rounded-full text-xs font-body">
                        {service.price}
                      </span>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* ==================== WHY CHOOSE US - SPLIT LAYOUT ==================== */}
      <section className="py-24 lg:py-32 bg-[#121212]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 lg:gap-24 items-center">
            {/* Image Side - Chef Jaylon */}
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              whileInView={{ opacity: 1, x: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.8 }}
              className="relative"
            >
              <div className="relative aspect-[3/4] rounded-2xl overflow-hidden">
                <img 
                  src={CHEF_JAYLON} 
                  alt="Chef Jaylon at a Royal Delights event" 
                  className="w-full h-full object-cover object-top"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-[#121212] via-transparent to-transparent" />
              </div>
              {/* Floating Badge */}
              <div className="absolute -bottom-6 -right-6 bg-[#D4AF37] rounded-2xl p-6 shadow-[0_0_60px_-10px_rgba(212,175,55,0.4)]">
                <p className="font-heading text-4xl font-bold text-black">100+</p>
                <p className="font-body text-sm text-black/70">Events Served</p>
              </div>
            </motion.div>

            {/* Content Side */}
            <motion.div
              initial="hidden"
              whileInView="visible"
              viewport={{ once: true, margin: "-100px" }}
              variants={staggerContainer}
            >
              <motion.p variants={fadeInUp} className="text-[#D4AF37] uppercase tracking-[0.2em] text-sm mb-4 font-body">
                The Royal Difference
              </motion.p>
              <motion.h2 variants={fadeInUp} className="font-heading text-4xl sm:text-5xl font-bold text-[#F5F5F0] mb-8">
                Why Families Choose Royal Delights
              </motion.h2>
              <motion.p variants={fadeInUp} className="font-body text-lg text-[#A1A1AA] mb-10 leading-relaxed">
                We don't just cater events — we craft experiences that become cherished memories. 
                Every detail is intentional, every flavor is soulful, and every moment is designed 
                to make you and your guests feel truly special.
              </motion.p>

              <motion.div variants={staggerContainer} className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                {whyChooseUs.map((item, index) => (
                  <motion.div 
                    key={index} 
                    variants={fadeInUp}
                    className="flex items-center gap-3 bg-[#050505] rounded-xl p-4 border border-white/5"
                  >
                    <span className="text-[#D4AF37] text-lg">{item.icon}</span>
                    <span className="font-body text-[#F5F5F0] text-sm">{item.text}</span>
                  </motion.div>
                ))}
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* ==================== SIGNATURE DISHES GALLERY ==================== */}
      <section className="py-24 lg:py-32 bg-[#050505]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            {/* Section Header */}
            <motion.div variants={fadeInUp} className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-16 gap-6">
              <div>
                <p className="text-[#D4AF37] uppercase tracking-[0.2em] text-sm mb-4 font-body">Culinary Excellence</p>
                <h2 className="font-heading text-4xl sm:text-5xl font-bold text-[#F5F5F0]">
                  Signature Creations
                </h2>
              </div>
              <Link to="/menu">
                <Button 
                  variant="outline"
                  data-testid="view-menu-btn"
                  className="border border-[#D4AF37] text-[#D4AF37] hover:bg-[#D4AF37] hover:text-black bg-transparent rounded-full px-6 py-3 transition-all duration-300"
                >
                  View Full Menu
                  <ArrowRight className="ml-2 w-4 h-4" />
                </Button>
              </Link>
            </motion.div>

            {/* Dishes Grid */}
            <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-6">
              {signatureDishes.map((dish, index) => (
                <motion.div
                  key={index}
                  variants={scaleIn}
                  className="group relative aspect-square rounded-2xl overflow-hidden"
                  data-testid={`dish-card-${index}`}
                >
                  <img 
                    src={dish.image} 
                    alt={dish.name}
                    className="w-full h-full object-cover transition-all duration-700 group-hover:scale-110 group-hover:brightness-110"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent opacity-80 group-hover:opacity-90 transition-opacity" />
                  <div className="absolute bottom-0 left-0 right-0 p-4 lg:p-6 transform translate-y-2 group-hover:translate-y-0 transition-transform duration-300">
                    <span className="font-body text-xs text-[#D4AF37] uppercase tracking-wider">{dish.subtitle}</span>
                    <h3 className="font-heading text-lg lg:text-xl font-bold text-[#F5F5F0] mt-1">{dish.name}</h3>
                    <p className="font-heading text-[#D4AF37] text-lg mt-2">{dish.price}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* ==================== TESTIMONIALS ==================== */}
      <section className="py-24 lg:py-32 bg-[#121212] relative overflow-hidden">
        {/* Background Image */}
        <div className="absolute inset-0 opacity-10">
          <img src={LUXURY_TABLE} alt="" className="w-full h-full object-cover" />
        </div>
        
        <div className="max-w-7xl mx-auto px-6 lg:px-8 relative z-10">
          <motion.div
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, margin: "-100px" }}
            variants={staggerContainer}
          >
            {/* Section Header */}
            <motion.div variants={fadeInUp} className="text-center mb-16">
              <p className="text-[#D4AF37] uppercase tracking-[0.2em] text-sm mb-4 font-body">Testimonials</p>
              <h2 className="font-heading text-4xl sm:text-5xl font-bold text-[#F5F5F0]">
                Stories of Celebration
              </h2>
            </motion.div>

            {/* Testimonials Grid */}
            <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
              {testimonials.map((testimonial, index) => (
                <motion.div
                  key={index}
                  variants={fadeInUp}
                  className="bg-[#050505]/80 backdrop-blur-sm border border-white/5 rounded-2xl p-8 relative group hover:border-[#D4AF37]/30 transition-colors duration-500"
                  data-testid={`testimonial-${index}`}
                >
                  {/* Quote Icon */}
                  <Quote className="w-10 h-10 text-[#D4AF37]/30 mb-6" />
                  
                  {/* Stars */}
                  <div className="flex gap-1 mb-6">
                    {[...Array(5)].map((_, i) => (
                      <Star key={i} className="w-4 h-4 fill-[#D4AF37] text-[#D4AF37]" />
                    ))}
                  </div>
                  
                  <p className="font-accent text-lg text-[#F5F5F0] italic leading-relaxed mb-8">
                    "{testimonial.quote}"
                  </p>
                  
                  <div className="border-t border-white/10 pt-6">
                    <p className="font-body font-semibold text-[#F5F5F0]">{testimonial.author}</p>
                    <p className="font-body text-sm text-[#D4AF37]">{testimonial.event}</p>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>
        </div>
      </section>

      {/* ==================== FINAL CTA ==================== */}
      <section className="py-32 lg:py-40 bg-[#050505] relative overflow-hidden">
        {/* Ambient Background */}
        <div className="absolute inset-0">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,_#D4AF37_0%,_transparent_70%)] opacity-5" />
        </div>
        
        <motion.div 
          className="max-w-4xl mx-auto px-6 lg:px-8 text-center relative z-10"
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={staggerContainer}
        >
          <motion.div variants={scaleIn} className="mb-8">
            <img src={LOGO_URL} alt="Royal Delights" className="w-24 h-24 mx-auto object-contain" />
          </motion.div>
          
          <motion.h2 
            variants={fadeInUp}
            className="font-heading text-4xl sm:text-5xl lg:text-6xl font-bold text-[#F5F5F0] mb-6"
          >
            Your Celebration Awaits
          </motion.h2>
          
          <motion.p 
            variants={fadeInUp}
            className="font-body text-lg text-[#A1A1AA] mb-12 max-w-2xl mx-auto leading-relaxed"
          >
            Join the families who have transformed their gatherings into unforgettable royal experiences. 
            Reserve your date with a $200 booking fee and let us handle the rest.
          </motion.p>
          
          <motion.div variants={fadeInUp} className="flex flex-wrap gap-4 justify-center">
            <Link to="/booking">
              <Button 
                data-testid="cta-reserve-btn"
                className="bg-[#D4AF37] text-black hover:bg-[#C5A028] font-semibold rounded-full px-10 py-6 text-base transition-all duration-300 hover:scale-105 shadow-[0_0_30px_-10px_rgba(212,175,55,0.5)]"
              >
                <Sparkles className="mr-2 w-5 h-5" />
                Reserve Your Date
              </Button>
            </Link>
            <Link to="/contact">
              <Button 
                variant="outline"
                className="border border-white/20 text-[#F5F5F0] hover:bg-white/10 bg-transparent rounded-full px-10 py-6 text-base transition-all duration-300"
              >
                Get in Touch
              </Button>
            </Link>
          </motion.div>
        </motion.div>
      </section>
    </div>
  );
};

export default HomePage;
